import { render, staticRenderFns } from "./GabungKelas.vue?vue&type=template&id=51c4f44e&"
import script from "./GabungKelas.vue?vue&type=script&lang=js&"
export * from "./GabungKelas.vue?vue&type=script&lang=js&"
import style0 from "./GabungKelas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports